import React, { useState, useEffect } from 'react';
import {
  Tabs,
  Tab,
  Box,
  Paper,
  Typography
} from '@mui/material';
import { Details } from '@mui/icons-material';

// A simple reusable TabPanel
function TabPanel(props) {
  const { children, value, index } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      style={{ marginTop: '16px' }}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const OverallDetails = ({ city, county, rawData }) => {
  const [tabValue, setTabValue] = useState(0);
  const [exceptions, setExceptions] = useState(null);
  const [fireHistory, setFireHistory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  var tabData = [
    { label: "City", value: city },
    { label: "County", value: county },
    { label: "Insurance", value: "Uninsurable" },
    { label: "Residential", value: county },
    { label: "Other", value: county },
  ];

  const findFiresByCity = () => {
    const lowercaseCityToFind = city.toLowerCase();
    return fireHistory.filter(item => {
      if (!item.cities || !Array.isArray(item.cities)) {
        return false;
      }
      return item.cities.some(city => city.toLowerCase() === lowercaseCityToFind);
    });
  }

  const findFiresByCounty = () => {
    const lowercaseCountyToFind = county.toLowerCase();
    return fireHistory.filter(item => {
      if (!item.counties || !Array.isArray(item.counties)) {
        return false;
      }
      return item.counties.some(county => county.toLowerCase() === lowercaseCountyToFind);
    });
  }


  


  const getLocationLogic = () => {
    const cities = findFiresByCity();
    const counties = findFiresByCounty();

    var summaryFuel = '';
    var summaryFire = '';

    if (rawData.fuel_risk.score < 0) {
      summaryFuel = "The brush in this area is at less risk than Pacific Palisades. While your risk may be somewhat lower, it is still strongly recommended that you contact your local officials to ensure brush is cleared and your fire risk is reduced.";
    } else if (rawData.fuel_risk.score === 0) {
      summaryFuel = "The brush in this area is at a comparable risk to Pacific Palisades. This means your community faces a similarly severe risk, and it is critical that you contact your local officials to clear brush and reduce the likelihood of fire destruction.";
    } else {
      summaryFuel = "The brush in this area is at a greater risk than Pacific Palisades. This places your community at an even higher danger level, and it is urgently recommended that you contact your local officials to clear brush and take immediate fire risk reduction measures.";
    }

    var data = {
      cities: cities,
      counties: counties,
      summary: {
        summaryFuel: summaryFuel,
        summaryFire: summaryFire
      }
    };

    return data;
  }


  const getInsuranceLogic = () => {

    var locations = getLocationLogic();

    var data = {
      value: 'At Risk',
      details: 'This area is within an urban/ residential area in California which makes it at risk of losing insurance coverage.'
    };

    if (!rawData.urban) {
      data.value = "N/A";
      data.details = "Not in an urban/ residential area.";
      return data;
    }

    if (rawData.fire_risk.score >= 0 || rawData.fuel_risk.score >= 0) {
      data.value = "Uninsurable";
      data.details = "This area meets the criteria for being uninsurable due to fire risk weather patterns, failure to clear brush on government owned land, and history of failures by the fire department in California.";
    }

    return data;
  }

  const getExceptionLogic = () => {
    const foundPeople = [];
    for (const person of exceptions) {
      if (person.zones.includes(rawData.code)) {
        foundPeople.push(person.name);
      }
    }
    return foundPeople;
  }

  const generateValueException = () => {
    var value = 'None';
    const data = getExceptionLogic();
    if (data.length < 1) {
      value = 'None';
    } else {
      value = 'Protected';
    }
    return value;
  };

  const generateValues = (index) => {
    switch (index) {
      case 0:
        return city;
        break;
      case 1:
        return county;
        break;
      case 2:
        var data = getInsuranceLogic();
        return data.value;
        break;
      case 3:
        return rawData.urban ? 'Yes' : 'No';
        break;
      case 4:
        return generateValueException();
        break;
      default:
        null();
    }
    return null;
  };


  
  const generateDetailsCity = () => {
    var data = getLocationLogic();
    if (data.cities.length < 1) {
      return (
        <>
          <Typography variant="body1">
            {data.summary.summaryFuel}  <br/><br/>
            FireRebuild is updating recent fire information for {city}.
          </Typography>
        </>
      );
    } else {
      return (
        <>
        <Typography variant="body1">
          {data.summary.summaryFuel}  <br/><br/>
          {city} has been known for the following fires:
        </Typography>
        {data.cities.map(({name, year, deaths, acres, structures_destroyed}, index) => (
          <Typography variant="body1" sx={{pl:2}}>
            <strong>{year} {name}</strong> with {deaths} deaths, {structures_destroyed} structures destroyed, and {acres} acres burned.
          </Typography>
        ))}
        </>
      );
    }
  };

  const generateDetailsCounty = () => {
    var data = getLocationLogic();
    if (data.counties.length < 1) {
      return (
        <>
          <Typography variant="body1">
            {data.summary.summaryFuel}  <br/><br/>
            FireRebuild is updating recent fire information for {county}.
          </Typography>
        </>
      );
    } else {
      return (
        <>
        <Typography variant="body1">
          {data.summary.summaryFuel}  <br/><br/>
          {county} has been known for the following fires:
        </Typography>
        {data.counties.map(({name, year, deaths, acres, structures_destroyed}, index) => (
          <Typography variant="body1" sx={{pl:2}}>
            <strong>{year} {name}</strong> with {deaths} deaths, {structures_destroyed} structures destroyed, and {acres} acres burned.
          </Typography>
        ))}
        </>
      );
    }
  };

  const generateDetailsInsurance = () => {
    var data = getInsuranceLogic();
    return (
      <>
        <Typography variant="body1">
          {data.details}
        </Typography>
      </>
    );
  };

  const generateDetailsResidential = () => {
    if (rawData.urban) {
      return (
        <>
          <Typography variant="body1">
            This area falls within a residential / urban zone.  Insurance is a requirement.
          </Typography>
        </>
      );
    } else {
      return (
        <>
          <Typography variant="body1">
            This area is not within a residential / urban zone.
          </Typography>
        </>
      );
    }
  };

  const generateDetailsException = () => {
    const data = getExceptionLogic();
    if (data.length < 1) {
      return (
        <>
          <Typography variant="body1">
            No exceptions found.
          </Typography>
        </>
      );
    } else {
      return (
        <>
          <Typography variant="body1">
            Congratulations!  Your location is near {data[0]}'s home!  You have a significantly less risk of a major fire in your area regardless of the overall risk.
          </Typography>
        </>
      );
    }
  };



  const generateDetails = (index) => {

    switch (index) {
      case 0:
        return generateDetailsCity();
        break;
      case 1:
        return generateDetailsCounty();
        break;
      case 2:
        return generateDetailsInsurance();
        break;
      case 3:
        return generateDetailsResidential();
        break;
      case 4:
        return generateDetailsException();
        break;
      default:
        null();
    }
    return (
      <>
        <Typography variant="body1"></Typography>
      </>
    );
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const [exceptionsResponse, fireHistoryResponse] = await Promise.all([
          fetch('https://app.firerebuild.com/fire-risk-zone/data/exceptions.json'),
          fetch('https://app.firerebuild.com/fire-risk-zone/data/fire_history.json')
        ]);

        if (!exceptionsResponse.ok) {
          throw new Error(`HTTP error! status: ${exceptionsResponse.status} for exceptions.json`);
        }
        if (!fireHistoryResponse.ok) {
          throw new Error(`HTTP error! status: ${fireHistoryResponse.status} for fire_history.json`);
        }

        const exceptionsData = await exceptionsResponse.json();
        const fireHistoryData = await fireHistoryResponse.json();
        setExceptions(exceptionsData);
        setFireHistory(fireHistoryData);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div>Loading data...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <>
      {/* Tab headers */}
      <Tabs
        value={tabValue}
        onChange={handleChange}
        variant="fullWidth"
        sx={{ borderBottom: 0, borderColor: 'divider' }}
      >
        {tabData.map((tab, index) => (
          <Tab
            key={index}
            sx={{
              minWidth: "20%",
              maxWidth: "20%",
              flexGrow: 1,
              textTransform: "none",
              padding: 0,
            }}
            label={
              <Paper
                className="p-6 bg-gray-700 rounded-xl shadow-inner border border-gray-600"
                sx={{
                  width: "100%",
                  height: "100%",
                  p: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                {/* Updated Typography for Tab Label */}
                <Typography
                  variant="h6"
                  className="text-md font-bold mb-2"
                  sx={{
                    color: tabValue === index ? 'black' : 'grey',
                  }}
                >
                  {tab.label}
                </Typography>
                {/* The following Typography component is also updated to match the above logic */}
                <Typography
                  variant="body1"
                  sx={{
                    color: tabValue === index ? 'black' : 'grey',
                  }}
                >
                  {generateValues(index)}
                </Typography>
              </Paper>
            }
          />
        ))}
      </Tabs>

      {/* Tab Panels */}
      {tabData.map((tab, index) => (
        <TabPanel key={index} value={tabValue} index={index}>
          <Paper
            sx={{
              p: 3,
            }}
          >
            {generateDetails(index)}
          </Paper>
        </TabPanel>
      ))}
    </>
  );
};

export default OverallDetails;









/*
              <Rating
                name={`rating-${category}`}
                value={processedData[category].rank}
                readOnly
                size="large"
                // Pass the color to the CSS variable
                sx={{ '--icon-color': ratingColors[processedData[category].rank] }}
              />

      <Box className="p-6 md:p-10 lg:p-12 min-h-screen bg-gray-900 text-white font-sans flex flex-col items-center justify-center">
        <div className="w-full max-w-4xl bg-gray-800 rounded-2xl shadow-lg p-6 md:p-8 lg:p-10 border border-gray-700">
          <Typography variant="h4" component="h1" className="text-3xl md:text-4xl font-extrabold text-center mb-6 text-orange-400">
            Fuel Risk Ratings
          </Typography>
          <Grid container spacing={4} className="mt-4">
            {Object.keys(processedData).map((category) => (
              <Grid item xs={12} sm={6} key={category}>
                <Paper className="p-6 bg-gray-700 rounded-xl shadow-inner border border-gray-600 h-full flex flex-col justify-between">
                  <div>
                    <Typography variant="h6" className="text-xl font-bold mb-2 text-orange-300">
                      {category}
                    </Typography>
                    <div className="flex items-center space-x-2 mb-4">
                      <Typography component="legend" className="font-semibold text-gray-200">
                        Risk Rating:
                      </Typography>
                      <Rating
                        name={`rating-${category}`}
                        value={processedData[category].rank}
                        readOnly
                        size="large"
                      />
                    </div>
                    {processedData[category].details.length > 0 ? (
                      <div>
                        <Typography className="text-sm font-medium text-gray-400 mb-2">
                          Details:
                        </Typography>
                        <ul className="list-disc list-inside space-y-1">
                          {processedData[category].details.map((detail, index) => (
                            <li key={index} className="text-gray-300 text-sm">
                              <span className="font-semibold">{detail.name}</span>: Value {detail.value} ({detail.miles} miles away)
                            </li>
                          ))}
                        </ul>
                      </div>
                    ) : (
                      <Typography className="text-gray-400 italic text-sm">
                        No data available for this category.
                      </Typography>
                    )}
                  </div>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </div>
      </Box>

*/